import React from "react";
import PropTypes from "prop-types";
import "./App.css";
import MapContext from "./components/MapContext";
import Providers from "./components/Providers";

export default function App({ googleMapsApiKey, baseUrl, dataUrl }) {
  return (
    <MapContext
      baseUrl={baseUrl}
      googleMapsApiKey={googleMapsApiKey}
      dataUrl={dataUrl}
    >
      <style>
        {`

body {
  --color-accent: #a00a00;
  font-size: 14px;
  font-family: Montserrat, Roboto, Helvetica, sans-serif;
}

* {
  box-sizing: border-box;
}

a {
  color: var(--color-accent);
  text-decoration: none;
}

h2 {
  font-size: 20px;
  margin: 0;
}

h3 {
  font-size: 15px;
  margin: 0px 0px 10px;
}

hr {
  border: 0;
  height: 1px;
  width: 100%;
  background: #eee;
  margin: 10px 0;
  flex-shrink: 0;
}

svg path {
  fill: currentColor
}
        `}
      </style>
      <Providers />
    </MapContext>
  );
}

App.defaultProps = {
  baseUrl: "",
  googleMapsApiKey: "",
  dataUrl: "",
};

App.propTypes = {
  baseUrl: PropTypes.string,
  googleMapsApiKey: PropTypes.string,
  dataUrl: PropTypes.string,
};
